import React, { useState, useCallback, useEffect } from "react";
import { Container, Row, Col } from "react-bootstrap";
import IDSTable from "./IDSTable";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import Form from "react-bootstrap/Form";
import Alert from "react-bootstrap/Alert";
import InputAdornment from "@mui/material/InputAdornment";
import TextField from "@mui/material/TextField";
import Accordion from "react-bootstrap/Accordion";
import FormGroup from "@mui/material/FormGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import { ERROR_MSG, S3_URL } from "../services/Constants";
import { unknownFacilityQueueHeadCells } from "../util/headcells-util";
import FullScreenSpinner from "./FullScreenSpinner";
import { getAllFacilities } from "../services/sendingFacilities-service";
import { useLocation, useNavigate } from "react-router-dom";
import { urlWithFilterParams } from "../util/common";
import {
  fetchUnknownFacilityTransactionDataWithFilter,
  reprocessBulkTransactionRecord,
  removeTransactionRecords,
} from "../services/errorMessageQueue-service";
import { useContext } from "react";
import UserContext from "../context/user-context";
import { componentIsVisible, validateAndSanitizeUrl } from "../util/common";
import { UFTDB } from "../util/component-codes";
import { FixedSizeList } from "react-window";
import Cookies from "js-cookie";

const UnknownFacilitiesQueue = () => {
  const location = useLocation();
  const [isLoading, setIsLoading] = useState();

  const handleError = () => {
    let value = false;
    if (location?.state?.isAdded != null) {
      value = !location?.state?.isAdded;
    } else if (location?.state?.isDeleted != null) {
      value = !location?.state?.isDeleted;
    } else if (location?.state?.isReprocess != null) {
      value = !location?.state?.isReprocess;
    }
    return value;
  };

  const [isReprocess, setIsReprocess] = useState(
    location?.state?.isReprocess != null ? location?.state?.isReprocess : false
  );
  const [isReprocessWithErrors, setIsReprocessWithErrors] = useState(
    location?.state?.isReprocessWithErrors != null
      ? location.state.isReprocessWithErrors
      : false
  );

  const [isDeleted, setIsDeleted] = useState(
    location?.state?.isDeleted != null ? location?.state?.isDeleted : false
  );
  const [isError, setIsError] = useState(handleError());
  const [showRemoveWarningModal, setShowRemoveWarningModal] = useState();
  const [showFilterModal, setShowFilterModal] = useState();
  const [alertMessage, setAlertMessage] = useState();
  const [filter, setFilter] = useState(
    location?.state?.filter ? location?.state?.filter : {}
  );
  const [isAdded, setIsAdded] = useState(
    location?.state?.isAdded != null ? location?.state?.isAdded : false
  );
  const [selectedRow, setSelectedRow] = useState([]);
  const [recordsPerPage, setRecordsPerPage] = useState(Cookies.get("itemsPerPage")?Cookies.get("itemsPerPage"):5);
  const [pageNo, setPageNo] = useState(0);
  const [isFetchError, setIsFetchError] = useState(false);
  const [transactionData, setTransactionData] = useState(null);
  const [checkedValues, setCheckedValues] = useState(location?.state?.filter?.sendingFacilityName ? location?.state?.filter?.sendingFacilityName :[]);
  const [facilityData, setFacilityData] = useState([]);
  const [isAllSelected, setIsAllSelected] = useState(false);
  const [showReprocessModal, setShowReprocessModal] = useState(false);

  const handleRemoveWarningModalClose = () => setShowRemoveWarningModal(false);
  const handleFilterModalClose = () => setShowFilterModal(false);
  const handleReprocessModalClose = () => setShowReprocessModal(false);

  const navigate = useNavigate();

  const [user] = useContext(UserContext);

  const getTransactionData = useCallback(
    async (filter) => {
      let response = await fetchUnknownFacilityTransactionDataWithFilter(
        pageNo,
        recordsPerPage,
        urlWithFilterParams(filter)
      );

      if (response.ok) {
        let data = await response.json();
        if (data.genericList != null) {
          const genericList = data.genericList.map((item) => ({
            ...item, 
            clia:  item?.sendingFacility?.clia,
            SendingFacilityidORcliaORoidORNPI:
            item?.msh12 === "eICR"
              ? item?.npi
              : item?.sendingFacility?.sendingFacilityIdentifier ||
                item?.sendingFacility?.clia ||
                item?.sendingFacility?.oid ||
                item?.sendingFacility?.npi,
         }));
         const data2={...data, genericList : genericList}
          setIsFetchError(false);
          setIsError(false);
          setTransactionData(data2);
        } else {
          setIsFetchError(true);
          setIsError(true);
        }
      } else {
        let error = await response.json();
        if (error.description === "No Transaction record found!") {
          setIsFetchError(false);
          setIsError(false);
          setTransactionData({
            genericList: [],
            totalPages: 0,
            totalRecords: 0,
          });
        } else {
          setIsFetchError(true);
          setIsError(true);
          setAlertMessage(error?.description);
        }
      }
    },
    [pageNo, recordsPerPage]
  );

  const discardErrorMessage = async () => {
    let response = await removeTransactionRecords(
      selectedRow?.map((obj) => obj?.transactionId)
    );
    if (response !== ERROR_MSG) {
      setIsDeleted(true);
      setSelectedRow([]);
    } else {
      setIsError(true);
    }
    handleRemoveWarningModalClose();
    setSelectedRow([]);
    setCheckedValues([]);
  };

  const setFilterField = (field, value) => {
    setFilter({
      ...filter,
      [field]: value,
    });
  };

  const handleAdd = () => {
    navigate("/facilityForm", {
      state: { from: "unknownFacilityErrorQueue" },
    });
  };

  const handleDiscardMessage = () => {
    setShowRemoveWarningModal(true);
    setIsAdded(false);
    setIsDeleted(false);
    setIsError(false);
    setIsReprocess(false);
    setIsReprocessWithErrors(false);
  };

  const getFacilities = async () => {
    let response = await getAllFacilities();
    if (response.ok) {
      let data = await response.json();
      setFacilityData(data);
    } else {
      let error = await response.json();
      setIsError(true);
      setAlertMessage(error?.description);
    }
  };

  const handleShowFilter = () => {
    setIsAdded(false);
    setIsDeleted(false);
    setIsError(false);
    setIsReprocess(false);
    setIsReprocessWithErrors(false);
    getFacilities();
    setShowFilterModal(true);
  };

  const handleFilter = (event) => {
    event.preventDefault();
    setPageNo(0);
    pageNo === 0 && getTransactionData(filter);
    handleFilterModalClose();
  };

  const handleCheckboxChange = (event) => {
    let copyCheckedValues = [...checkedValues];

    if (copyCheckedValues.includes(event.target.name)) {
      copyCheckedValues = copyCheckedValues.filter(
        (item) => item !== event.target.name
      );
    } else {
      copyCheckedValues = [...copyCheckedValues, event.target.name];
    }
    setCheckedValues(copyCheckedValues);
    setFilterField("sendingFacilityName", copyCheckedValues);
  };

  const handleResetFilter = () => {
    setCheckedValues([]);
    setFilter({});
  };

  const setSelectedRowCallback = (row) => {
    setSelectedRow(row);
  };

  const setRecordsPerPageCallback = (value) => {
    setRecordsPerPage(value);
  };

  const setPageNoCallback = (value) => {
    setPageNo(value);
  };

  useEffect(() => {
    getTransactionData(filter);
  }, [pageNo, recordsPerPage, getTransactionData]);

  useEffect(() => {
    if (isDeleted) {
      getTransactionData(filter);
    }
  }, [isDeleted, getTransactionData]);

  useEffect(() => {
    if (pageNo >= transactionData?.totalPages) {
      transactionData?.totalPages !== 0 &&
        setPageNo(transactionData?.totalPages - 1);
    }
  }, [transactionData]);

  const reprocessTransaction = async () => {
    setIsError(false);
    setIsDeleted(false);
    setIsLoading(true);
    setIsReprocess(false);
    setIsReprocessWithErrors(false);
    let response = await reprocessBulkTransactionRecord(
      isAllSelected
      ? {
          ...filter,
          errorCode: filter?.errorCode
            ? filter?.errorCode
            : [
                "VE08"
              ],
        }
      : { transId: selectedRow?.map((obj) => obj.transactionId) }
    );
    if (response?.responsecode === "0") {
      setIsReprocess(true);
    } else if (response?.responsecode === "1") {
      setIsReprocessWithErrors(true);
    } else {
      setIsError(true);
    }
    setIsLoading(false);
    getTransactionData(filter);
    setShowReprocessModal(false);
    setSelectedRow([]);
    setCheckedValues([]);
  };

  const buttonsLayout = () => {
    return (
      <div className="flexCenter">
        <Button
          className="reprocessButtonStyle generalFont flexCenter"
          disabled={
            (selectedRow === null || selectedRow?.length === 0) &&
            isAllSelected === false
          }
          onClick={() => setShowReprocessModal(true)}
        >
          <img
            src={`${validateAndSanitizeUrl(S3_URL)}reprocess-icon.png`}
            className="buttonIcon"
            alt=""
          ></img>
          Reprocess
        </Button>
        {componentIsVisible(UFTDB, user) && (
          <Button
            className="removeButtonStyle generalFont flexCenter"
            onClick={handleDiscardMessage}
            disabled={
              (selectedRow === null || selectedRow?.length === 0) &&
              isAllSelected === false
            }
          >
            <img
              src={`${validateAndSanitizeUrl(S3_URL)}delete-icon.png`}
              className="buttonIcon"
              alt=""
            ></img>
            Discard Message
          </Button>
        )}
      </div>
    );
  };

  const renderBannerMessage = () => {
    if (isDeleted) {
      return "Successfully discarded transactions!";
    } else if (isAdded) {
      return "Successfully added new Facility!";
    } else if (isReprocess) {
      return "Transaction Message successfully reprocessed!";
    } else if (isReprocessWithErrors) {
      return "Transaction Message successfully reprocessed but there are still errors!";
    } else if (isError) {
      return alertMessage
        ? alertMessage
        : "Something went wrong, please try again!";
    }
  };

  const setExpandedAccordion = () => {
    let active = [];
    if (filter?.startDate || filter?.endDate) {
      active.push("0");
    }
    if (checkedValues.length > 0) {
      active.push("1");
    }
    return active;
  };

  return (
    <>
      <Container fluid className="facilitiesContainer">
        {isLoading && <FullScreenSpinner />}
        <Row style={{ marginLeft: "0px" }}>
          <Col xl={8}>
            <Row className="tableTitle generalFont">Unknown Facility Queue</Row>
            <Row className="tableSubtitle generalFont">
              You have{" "}
              {transactionData?.totalRecords > 0
                ? transactionData.totalRecords
                : 0}{" "}
              Error Messages Awaiting action{" "}
            </Row>
          </Col>
        </Row>
        {(isAdded ||
          isDeleted ||
          isError ||
          isReprocess ||
          isReprocessWithErrors) && (
          <Alert
            style={{ marginRight: "125px" }}
            key={"success"}
            variant={isError ? "danger" : "success"}
            onClose={() => {
              setIsAdded(false);
              setIsDeleted(false);
              setIsError(false);
              setIsReprocess(false);
              setIsReprocessWithErrors(false);
            }}
            dismissible
          >
            {renderBannerMessage()}
          </Alert>
        )}
        <IDSTable
          isFetchError={isFetchError}
          setPageNoCallback={setPageNoCallback}
          setRecordsPerPageCallback={setRecordsPerPageCallback}
          headCells={unknownFacilityQueueHeadCells}
          rows={transactionData?.genericList}
          pages={transactionData?.totalPages}
          buttonsLayout={buttonsLayout}
          addButtonName="Add New Sending Facility"
          addButtonAction={handleAdd}
          selectedRows={selectedRow}
          setSelectedRowCallback={setSelectedRowCallback}
          handleShowFilter={handleShowFilter}
          isUnknownFacilityTable={true}
          isAllSelected={isAllSelected}
          setIsAllSelected={setIsAllSelected}
          isAllSelectedDisabled={
            transactionData === null || transactionData.totalRecords === 0
          }
          filter={filter}
        />
      </Container>

      <Modal
        show={showReprocessModal}
        onHide={handleReprocessModalClose}
        size="lg"
        centered
      >
        <Modal.Header className="modalHeaderContainer" closeButton>
          <Modal.Title className="modalHeader generalFont">
            Reprocess Error Message Queue
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="modalBodyContainer">
          <React.Fragment>
            {isAllSelected ? (
              <Form.Label className="modalLabel generalFont">
                Are you sure you want to reprocess all the{" "}
                {transactionData?.totalRecords > 0
                  ? transactionData.totalRecords
                  : 0}{" "}
                errors with the following filter condition?
              </Form.Label>
            ) : (
              <>
                <Form.Label className="modalLabel generalFont">
                  Are you sure you want to reprocess these{" "}
                  {selectedRow && selectedRow?.length} errors from the list?
                </Form.Label>
                <br />
                <Form.Label className="modalLabel generalFont">
                  {selectedRow
                    ?.map((obj) => obj.transactionId)
                    .map((row, index) => {
                      return <div>{row}</div>;
                    })}
                </Form.Label>
              </>
            )}
          </React.Fragment>
        </Modal.Body>
        <Modal.Footer className="modalFooterContainer">
          <Button
            onClick={handleReprocessModalClose}
            className="modalCancelStyle generalFont flexCenter"
            variant="secondary"
          >
            Cancel
          </Button>
          <Button
            onClick={reprocessTransaction}
            className="addNewBtn generalFont flexCenter"
          >
            Reprocess
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal
        show={showRemoveWarningModal}
        onHide={handleRemoveWarningModalClose}
        size="lg"
        centered
      >
        <Modal.Header className="modalHeaderContainer" closeButton>
          <Modal.Title className="modalHeader generalFont">
            Discard Message
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="modalBodyContainer">
          <React.Fragment>
            <Form.Label className="modalLabel generalFont">
              Are you sure you want to remove these Error Message from the
              Table?
              <br />
              {selectedRow
                ?.map((obj) => obj.transactionId)
                .map((row, index) => {
                  return <div>{row}</div>;
                })}
              <br />
              The Error Message will no longer be visible on the screen
            </Form.Label>
          </React.Fragment>
        </Modal.Body>
        <Modal.Footer className="modalFooterContainer">
          <Button
            onClick={handleRemoveWarningModalClose}
            className="modalCancelStyle generalFont flexCenter"
            variant="secondary"
          >
            Cancel
          </Button>
          <Button
            onClick={discardErrorMessage}
            className="modalRemoveStyle generalFont flexCenter"
          >
            Discard
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal
        show={showFilterModal}
        onHide={handleFilterModalClose}
        size="sm"
        centered
        dialogClassName="my-modal-30"
      >
        <Modal.Header className="modalHeaderContainer" closeButton>
          <Modal.Title className="modalHeader generalFont">
            Apply Filters
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="modalBodyContainer">
          <React.Fragment>
            <Form.Label className="modalLabel generalFont">
              <TextField
                className="my-modal-searchbox-30"
                size="small"
                placeholder="Identifier"
                value={filter.id ? filter.id : ""}
                onChange={(e) =>
                  setFilterField(
                    "id",
                    e.target.value.length > 0 ? e.target.value : null
                  )
                }
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="start">
                      <img
                        src={`${validateAndSanitizeUrl(S3_URL)}search-icon.png`}
                        alt=""
                        style={{ height: "19px", width: "19px" }}
                      ></img>
                    </InputAdornment>
                  ),
                }}
              />
            </Form.Label>
            <br />
            <br />
            <Form.Label className="modalLabel generalFont">
              <TextField
                className="my-modal-searchbox-30"
                size="small"
                placeholder="Message Control ID"
                value={filter.messageControlId ? filter.messageControlId : ""}
                onChange={(e) =>
                  setFilterField(
                    "messageControlId",
                    e.target.value.length > 0 ? e.target.value : null
                  )
                }
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="start">
                      <img
                        src={`${validateAndSanitizeUrl(S3_URL)}search-icon.png`}
                        alt=""
                        style={{ height: "19px", width: "19px" }}
                      ></img>
                    </InputAdornment>
                  ),
                }}
              />
            </Form.Label>
            <br />
            <br />
            <Form.Label className="modalLabel generalFont">
              <TextField
                className="my-modal-searchbox-30"
                size="small"
                placeholder="Specimen ID"
                value={filter.specimenId ? filter.specimenId : ""}
                onChange={(e) =>
                  setFilterField(
                    "specimenId",
                    e.target.value.length > 0 ? e.target.value : null
                  )
                }
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="start">
                      <img
                        src={`${validateAndSanitizeUrl(S3_URL)}search-icon.png`}
                        alt=""
                        style={{ height: "19px", width: "19px" }}
                      ></img>
                    </InputAdornment>
                  ),
                }}
              />
            </Form.Label>
            <br />
            <br />
            <Form.Label className="modalLabel generalFont">
              <TextField
                className="my-modal-searchbox-30"
                size="small"
                placeholder="CLIA"
                value={filter.npi ? filter.npi : ""}
                onChange={(e) =>
                  setFilterField(
                    "npi",
                    e.target.value.length > 0 ? e.target.value : null
                  )
                }
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="start">
                      <img
                        src={`${validateAndSanitizeUrl(S3_URL)}search-icon.png`}
                        alt=""
                        style={{ height: "19px", width: "19px" }}
                      ></img>
                    </InputAdornment>
                  ),
                }}
              />
            </Form.Label>
            <br />
            <br />
            <Accordion
              alwaysOpen
              disablegutters="true"
              defaultActiveKey={setExpandedAccordion()}
            >
              <Accordion.Item eventKey="0">
                <Accordion.Header>
                  <div className="bold">Time Transaction Received</div>
                </Accordion.Header>
                <Accordion.Body>
                  <br />
                  <Form.Group className="mb-3" controlId="form.startDate">
                    <React.Fragment>
                      <Form.Label className="modalLabel generalFont">
                        Start Date <i className="text-danger"></i>
                      </Form.Label>
                    </React.Fragment>
                    <Form.Control
                      className="modalInput generalFont"
                      type="date"
                      placeholder="Enter Text"
                      required
                      value={filter.startDate ? filter.startDate : ""}
                      onChange={(e) =>
                        setFilterField("startDate", e.target.value)
                      }
                    />
                  </Form.Group>

                  <Form.Group className="mb-3" controlId="form.endDate">
                    <React.Fragment>
                      <Form.Label className="modalLabel generalFont">
                        End Date <i className="text-danger"></i>
                      </Form.Label>
                    </React.Fragment>
                    <Form.Control
                      className="modalInput generalFont"
                      type="date"
                      placeholder="Enter Text"
                      required
                      value={filter.endDate ? filter.endDate : ""}
                      onChange={(e) =>
                        setFilterField("endDate", e.target.value)
                      }
                    />
                  </Form.Group>
                </Accordion.Body>
              </Accordion.Item>
              <br />
              <Accordion.Item eventKey="1">
                <Accordion.Header>
                  <div className="bold">Sending Facility</div>
                </Accordion.Header>
                <Accordion.Body
                  style={{
                    maxHeight: "200px",
                    overflow: "hidden",
                  }}
                >
                  <br />
                  <FormGroup>
                    <FixedSizeList
                      height={200}
                      itemSize={40}
                      itemCount={
                        facilityData.sort((a, b) =>
                          a.sendingFacilityName.localeCompare(
                            b.sendingFacilityName
                          )
                        ).length
                      }
                    >
                      {({ index, style }) => (
                        <div style={style}>
                          <FormControlLabel
                            control={
                              <Checkbox
                                checked={checkedValues.includes(
                                  facilityData[index].sendingFacilityName
                                )}
                                onChange={handleCheckboxChange}
                                name={facilityData[index].sendingFacilityName}
                              />
                            }
                            label={facilityData[index].sendingFacilityName}
                          />
                        </div>
                      )}
                    </FixedSizeList>
                  </FormGroup>
                </Accordion.Body>
              </Accordion.Item>
            </Accordion>
          </React.Fragment>
        </Modal.Body>
        <Modal.Footer
          className="modalFooterContainer"
          style={{ justifyContent: "space-between", marginLeft: "23px" }}
        >
          <Button
            onClick={handleResetFilter}
            className="modalAddUpdateStyle generalFont flexCenter modalRemoveStyle"
          >
            Reset
          </Button>
          <Button
            onClick={handleFilter}
            className="modalAddUpdateStyle generalFont flexCenter"
          >
            Filter
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default UnknownFacilitiesQueue;
